import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@heroui/react";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import { apiRoute, linksUrl } from "../../constants/enum";
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components";
import { COLUMN_ALIGN_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable";
import { toast } from "react-toastify";
import ConfirmBox from "../../components/ConfirmBox";
import { setDetailParams, setNewEntryMode } from "../../state/reportTemplateSlice";


const ItemGroupMaster = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { compCode } = useSelector((state) => state.company);

    const [itemToDelete, setItemToDelete] = useState("")

    // Fetch shape data
    const {
        data,
        isPending,
        isError,
        mutate:filterData
    } = usePost({
        url: apiRoute.reportTemplate.fetch,
        queryKey: "fetchTemplateMaster",
    });

    const funLoadData = () => {
        filterData({
            data: {compcode:compCode.join(",")}
        })
    }
    useEffect(() => {
        funLoadData();
    }, [])


    const onSuccessDelete = () => {
       setItemToDelete("")
       funLoadData()
    };

    // Delete shape mutation
    const { mutate: fnDelete } = usePost({
        url: apiRoute.reportTemplate.deleteEntry,
        queryKey: "deletereporttemplateMaster",
        onSuccessTasks: onSuccessDelete,
        //successMessage: "Item Group deleted successfully!",
    });

    const exportColumns = [
        {
            name: "Report",
            uid: "ReportType",
        },
        {
            name: "Template",
            uid: "TempName",
        },
    ]

     let downloadDataFooter = {
        ReportType: "",
        TempName: "",
    }

    const handleConfirmBox = (data) => {
        if (data) {
            fnDelete({ data:{ compcode:compCode.join(","), rpt_type: itemToDelete}});
        }
        else
        setItemToDelete("")
    };
    
    const handleAddNew = () => {
        dispatch(setNewEntryMode(true));
        dispatch(setDetailParams([])); 
        navigate(linksUrl.reportTemplate.createEntry);
    };

    

    const columns = [
        { name: "Actions", uid: "actions", align: COLUMN_ALIGN_TYPE.center },
        { name: "Report", uid: "ReportType", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Template", uid: "TempName", sortable: true, align: COLUMN_ALIGN_TYPE.center },
    ];

    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon icon={faEdit} style={{ color: "#379906" }} />,
            onClick: (row) => {
                let obj={
                    rpt_type:row.ReportType
                };
                dispatch(setDetailParams(obj));
                dispatch(setNewEntryMode(false))
                navigate(linksUrl.reportTemplate.createEntry);
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon icon={faTrash} style={{ color: "#c40c18" }} />,
            onClick: (row) => {
                setItemToDelete(row.ReportType)
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
    ];        

    if (isPending) return <LoadingCard/>;
    if (isError) return <ErrorCard/>;

    return (
        <div>
            <MainContainer pageName="Report Template" breadcrumbs={["Setting", "Report Template "]}>
                <div className="text-right mb-4">
                    <Button size="sm" color="primary" startContent={<FontAwesomeIcon icon={faPlus} />} onPress={handleAddNew}>
                        Add New
                    </Button>
                </div>
                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={["actions", "ReportType", "TempName", ]}
                    data={data}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    showAdvanceFilter={false}
                    exportColumns={exportColumns}
                    downloadDataFooter={downloadDataFooter}
                    downloadFileName="Template-master-List"
                    id="TempCode"
                    
                />
            </MainContainer>

            {itemToDelete && itemToDelete!="" && <ConfirmBox handleConfirmBox={handleConfirmBox} />}
        </div>
    );
};

export default ItemGroupMaster;
